module.exports = __webpack_public_path__ + "static/media/logAttitudeActive.223f4fe3.svg";